
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.5 21A10.5 10.5 0 1121 10.5 10.51 10.51 0 0110.5 21zm0-20a9.5 9.5 0 109.5 9.5A9.51 9.51 0 0010.5 1z"}}),_c('path',{attrs:{"d":"M23.5 24a.5.5 0 01-.35-.15l-5.94-5.93a.5.5 0 01.71-.7l5.93 5.93a.5.5 0 01-.35.85zm-10-16.75h-6a.5.5 0 010-1h6a.5.5 0 010 1z"}}),_c('path',{attrs:{"d":"M10.5 14.75a.5.5 0 01-.5-.5v-7.5a.5.5 0 011 0v7.5a.5.5 0 01-.5.5z"}})])
          )
        }
      }
    